import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { userIdentifierSchema } from '../schemas/user-identifier.schema';

/**
 * Get a list of Asset Identifiers by the partner externalIdType
 * @returns Array of Asset Identifiers
 */
export function getPartnerIntegrationUserIdentifiers(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        accountsEnvironment.resolve(this).partnerIntegrationUserIdentifiersUrl,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
              ? new AuthHeaders()
              : jwtAuthHeaders),
          },
        }
      )
    )
  ).pipe(selectData(z.array(userIdentifierSchema)));
}
